export default {
	week (week = 0) {
		let lastThursday
		const now = new Date()
		if (week < 0) {
			// lastThursday = (week * 7 + 4) - now.getDay()
			if (now.getDay() < 4) {
				lastThursday = ((week + -1) * 7 + 4) - now.getDay()
			} else {
				lastThursday = (week * 7 + 4) - now.getDay()
			}
		} else {
			if (now.getDay() < 4) {
				lastThursday = (-7 + 4) - now.getDay()
			} else {
				lastThursday = (4) - now.getDay()
			}
		}
		const currentMs = now.getTime()
		const star = new Date(currentMs + (lastThursday * 24 * 60 * 60 * 1000))
		const end = new Date(currentMs + ((lastThursday + 7 - 1) * 24 * 60 * 60 * 1000))

		return [star, end]
	}
}



// WEBPACK FOOTER //
// ./src/libs/date/period.js